module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_M3-e12af2b81012ce606d9ffb1dee5f60e4.webp";